import React from "react"
import '../styles/Loader.css'

export function Loader() {
    return (
        <div className="center">
            <div className="loader"/>
            <br/>
            <div>Loading...</div>
        </div>
    )
}
